<template>
    <div class="relative-article">
        <el-row>
            <el-col :span="6">
                <span>{{ `资源名称：` }}</span>
                <el-input v-model="artName" style="width: 150px;" placeholder="请输入文章名称" clearable></el-input>
            </el-col>
            <el-col :span="6">
                <span>{{ `资源分类：` }}</span>
                <el-cascader v-model="categoryId" placeholder="请选择" :options="courseCategory"
                    :props="{ expandTrigger: 'hover', emitPath: false }" clearable>
                </el-cascader>
            </el-col>

            <!-- 1 视频 2 音频 3 压缩包 4 图片 5 文件  -->
            <el-col :span="6">
                <div v-if="type !== 0">
                    <span>{{ `资源类型：` }}</span>
                    <el-select v-model="fileType" placeholder="请选择资源类型">
                        <el-option v-for="t in fileTypeOpt" :key="t.val" :label="t.label" :value="t.val"></el-option>
                    </el-select>
                </div>
                <div v-else>&nbsp;</div>
            </el-col>
            <el-col :span="6">
                <div class="box box-align-center box-pack-end mt-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button plain icon="el-icon-refresh" @click="search('refresh')">重置</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="mt12 conmmon-table">
            <dy-table :columns="columns_" :table-data="tableData" ref="table" v-loading="tableLoading" :total="total"
                :page-num="pageNum" :page-size="10" @current-change="onCurrentChange" rowKeyName="resourceId"
                @selection-change="onSelectionChange" element-loading-text="加载中"></dy-table>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px">
                <el-button type="primary" plain @click="saveData">保存</el-button>
                <el-button type="danger" plain @click="closeDialog">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import { getSelectCourseList } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
    name: 'articleCommon',
    components: {
        DyTable
    },
    props: {
        type: {
            type: Number,
            default: 0,
        },
        title: {
            type: String,
            default: "选择",
        },
        columns: {
            type: Array,
            default: []
        },
        list: {
            type: Array,
            default: () => [],
        }
    },
    computed: {
        // 使用 computed 计算每行的索引
        indexMethod() {
            return (index) => {
                return (this.pageNum - 1) * this.pageSize + index + 1;
            };
        },
    },
    watch: {
        list(newVal, oldVal) {
            this.setSelect();
        }
    },
    data() {
        return {
            artName: '',
            categoryId: '',
            fileType: "",
            fileTypeOpt: [
                {
                    label: "视频",
                    val: 1,
                },
                {
                    label: "音频",
                    val: 2,
                },
                {
                    label: "压缩包",
                    val: 3,
                },
                {
                    label: "图片",
                    val: 4,
                },
                {
                    label: "文件",
                    val: 5,
                },
            ],

            searchForm: {},
            tableLoading: true,
            pageNum: 1,
            pageSize: 10,
            options: [],
            columns_: [],
            tableData: [],
            total: 0,

            courseCategory: [],

            selectId: [],
            selection: [],
            isCurrentChange: false,
        }
    },
    created() {
        this.columns_ = [
            {
                type: "selection",
                width: "55",
            },
            {
                type: 'index',
                title: '序号',
                index: this.indexMethod
            },
            {
                key: 'resourceId',
                title: `${this.title}ID`
            },
            ...this.columns
        ]

    },
    mounted() {
        this.selectId = this.list.map(e => {
            return e.resourceId
        });
        this.selection = this.list;
        this.getCourseCategory()
        this.getList('init');
        // this.getAllClassification();

    },
    methods: {
        async getCourseCategory() {
            this.courseCategory = await this.$store.dispatch('category/getCourseCategory');
        },


        // 关闭弹窗
        closeDialog() {
            this.$emit('close-dialog');
        },
        onSelectionChange(val) {
            if (this.isCurrentChange) {
                this.isCurrentChange = false
                return
            }
            let pageId = this.tableData.map(e => {
                return e.resourceId
            })
            let selId = val.map(e => {
                return e.resourceId
            })
            let delId = pageId.filter(id => !selId.includes(id));
            this.selectId = [...new Set([...this.selectId, ...pageId].filter(id => !delId.includes(id)))];

            // 合并数组
            this.selection = [...this.selection, ...val];

            // 根据 ID 去重
            this.selection = Array.from(
                new Map(this.selection.map(item => [item.resourceId, item])).values()
            );

            this.selection = this.selection.filter(e => !delId.includes(e.resourceId));
        },
        saveData() {
            this.$emit('saveData', this.selection);
            this.$emit('close-dialog');
        },
        onCurrentChange(val) {
            this.isCurrentChange = true;
            this.pageNum = val;
            this.getList();
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childClass != '' && arr[i].childClass != null && arr[i].childClass != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childClass),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },

        search(msg) {
            this.pageNum = 1;
            this.searchForm = {
                categoryId: this.categoryId,
                name: this.artName,
                fileType: this.fileType,
            }
            if (msg == 'refresh') {
                this.artName = '';
                this.categoryId = '';
                this.fileType = "";
                this.searchForm = {};
            }
            this.getList();

        },

        //获取文章列表
        getList(msg) {
            this.tableLoading = true;
            let info = {
                page: this.pageNum,
                pageSize: this.pageSize,
                ...this.searchForm
            };
            console.log('info :>> ', info);
            // 1视频,2音频,3压缩包,4图片,5文件
            if (this.type == 0) {
                info.fileType = 1;
            }
            var data = encrypt(JSON.stringify(info));
            getSelectCourseList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    this.tableLoading = false;
                    this.total = ress.total;
                    this.tableData = ress.list;

                    for (let e of this.tableData) {
                        e.resourceId = e.id;
                        e.type = this.type;
                        e.resourceName = e.name;
                        e.resourceCategoryName = e.categoryName;
                        e.resourceType = this.fileTypeOpt.find((opt) => opt.val === e.fileType).label || "未知类型";
                        delete e['id']
                    }
                    this.setSelect();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        setSelect() {
            this.$nextTick(() => {
                this.$refs.table.$refs.ElTable.clearSelection();
                let sel = this.tableData.filter(item => this.selectId.includes(item.resourceId) || this.selectId.includes(item.id));
                sel.forEach(e => {
                    this.$refs.table.toggleRowSelection(e, true);
                });
            })
        }
    }
}
</script>
<style scoped>
.ra-table {
    margin-top: 12px;
    margin-bottom: 22px;
}
</style>